import type { OtimAPIClientConfig } from "../api/api-client";

// CORS configuration for different environments.
export const corsConfigs = {
  // For development with a local proxy.
  development: {
    // Assuming proxy is set up to forward /api to the actual API.
    baseURL: "/api",
    withCredentials: false,
  },

  // For production with proper CORS headers from server.
  production: {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  },

  // For apis that require credentials (cookies, auth headers).
  withCredentials: {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  },
} satisfies Record<string, Partial<OtimAPIClientConfig>>;

// Detect if running in browser environment.
export const isBrowser =
  typeof window !== "undefined" && typeof window.document !== "undefined";

// Detect if running in node.js environment.
export const isNode =
  typeof process !== "undefined" &&
  process.versions != null &&
  process.versions.node != null;

// Get CORS-safe configuration based on environment.
export function getCorsConfig(
  environment?: "development" | "production" | "withCredentials",
): Partial<OtimAPIClientConfig> {
  if (isNode) {
    return {};
  }

  if (environment && environment in corsConfigs) {
    return corsConfigs[environment];
  }

  return corsConfigs.production;
}

/**
 * Create a proxy url for development.
 * Useful when running a local dev server with proxy.
 */
export function createProxyUrl(path: string, proxyBase = "/api"): string {
  return `${proxyBase}${path.startsWith("/") ? path : `/${path}`}`;
}
